import { normalize, schema } from 'normalizr';
import {
  questionSchema,
  matrixQuestionSchema,
  questionBlockSchema,
} from './survey';

import {
  recommendationListSchema,
  recommendationSchema,
} from './recommendationSchema';

import { hiddenTagListSchema, tagUnionSchema } from './tagSchema';

import { tagSearchResultsSchema } from './tagSchema';

const userSchema = new schema.Entity('users', {}, { idAttribute: 'uuid' });

export {
  normalize as default,
  userSchema,
  questionSchema,
  matrixQuestionSchema,
  questionBlockSchema,
  recommendationListSchema,
  recommendationSchema,
  hiddenTagListSchema,
  tagSearchResultsSchema,
  tagUnionSchema,
};



// WEBPACK FOOTER //
// ./src/schema/index.js